module.exports = __webpack_public_path__ + "img/fenntartasi_jelentes_v2.e3148d5b.jpg";